import React from "react";
import { useSelector, useDispatch } from "react-redux";

import Slide from "@mui/material/Slide";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

import { closeSnackbar } from "../../slices/snackbar";

const Alert = React.forwardRef((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));

Alert.displayName = "Alert";

const CustomSnackbar = () => {
  const dispatch = useDispatch();
  const snackbar = useSelector((state) => state.snackbar);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(closeSnackbar());
  };
  // success, error, or info
  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={7500}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }} // Position at bottom-left
      TransitionComponent={Slide} // Use Slide transition
      sx={{ maxWidth: "30%" }}
    >
      <Alert
        onClose={handleClose}
        severity={snackbar.severity}
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
